var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"pa-3",attrs:{"cols":"12"}},[_c('zone-crud')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }